import { BooleanGambit } from 'flarum/common/query/IGambit';
import app from 'flarum/common/app';
export default class StickyGambit extends BooleanGambit {
  key() {
    return app.translator.trans('flarum-sticky.lib.gambits.discussions.sticky.key', {}, true);
  }
  filterKey() {
    return 'sticky';
  }
}
flarum.reg.add('flarum-sticky', 'common/query/discussions/StickyGambit', StickyGambit);